import React from 'react'
import { UserConsumer } from '../../../providers/user.provider'
import { HelpModal } from '../../help/help-modal.component'

export const MissingSchoolHelp = ({modalRef}) =>
  <UserConsumer>
    {({logout}) =>
      <HelpModal innerRef={modalRef} onClose={logout} />
    }
  </UserConsumer>